import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";


const ConfirmRedirectDialog = ({ open, close, confirm }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t('myevents.redirectdialog.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText >
          {t('myevents.redirectdialog.content')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>{t('dialog.cancel.button')}</Button>
        <Button onClick={confirm} autoFocus>
         {t('dialog.go.button')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmRedirectDialog;
